/**
Author - Brijesh Pandey
Git - https://github.com/Brijesh-Pandey
**/

import React from 'react';

import styled from 'styled-components';

import PropTypes from 'prop-types';

const downArrow = 'https://i.wlycdn.com/wealthy-home-page/partners-dropdown-arrow.svg';

const SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
};

const propTypes = {
  dropdownRef: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  setShowDropdown: PropTypes.func.isRequired,
  showDropdown: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  size: PropTypes.oneOf(Object.values(SIZES)),
};

const Dropdown = ({
  showDropdown,
  setShowDropdown,
  options,
  title,
  dropdownRef,
  size = SIZES.MEDIUM,
}) => (
  <DropdownContainer ref={dropdownRef} onClick={() => setShowDropdown(!showDropdown)} size={size}>
    <TitleContainer className="text-black" size={size}>
      {title}
    </TitleContainer>
    <DropdownImage size={size}>
      <img alt="dropdown-icon" loading="lazy" src={downArrow} />
    </DropdownImage>
    {showDropdown && <ul className="dropdown-menu">{options}</ul>}
  </DropdownContainer>
);

const getSizeValue = (size, values) => {
  const sizeMap = {
    [SIZES.SMALL]: values.small,
    [SIZES.MEDIUM]: values.medium,
    [SIZES.LARGE]: values.large,
  };
  return sizeMap[size] || values.medium;
};

const DropdownImage = styled.div`
  width: ${(props) => getSizeValue(props.size, {small: '1.6rem', medium: '2rem', large: '2.4rem'})};
  cursor: pointer;
  @media (max-width: 768px) {
    width: ${(props) =>
      getSizeValue(props.size, {small: '1.2rem', medium: '1.6rem', large: '1.8rem'})};
    > img {
      width: 100%;
      vertical-align: middle;
    }
  }
`;

const TitleContainer = styled.div.attrs({})`
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: ${(props) =>
    getSizeValue(props.size, {small: '1rem', medium: '1.4rem', large: '1.6rem'})};
  @media (max-width: 768px) {
    font-size: ${(props) =>
      getSizeValue(props.size, {small: '1rem', medium: '1.2rem', large: '1.4rem'})};
  }
`;

const DropdownContainer = styled.div`
  position: relative;
  display: flex;
  padding: ${(props) =>
    getSizeValue(props.size, {
      small: '0.4rem 1.2rem',
      medium: '0.8rem 1.8rem',
      large: '1rem 2.4rem',
    })};
  width: 100%;
  margin: 0 auto 3rem;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  border-radius: 4px;
  height: ${(props) => getSizeValue(props.size, {small: '3.2rem', medium: '4rem', large: '5rem'})};
  /* box-shadow: 4px 4px 20px rgb(0 0 0 / 15%); */
  color: #6c6c6c;
  font-weight: 500;
  transition: all 0.2s ease-in-out;
  position: relative;
  z-index: 2;
  border: 1px solid #6725f4;

  .dropdown-menu {
    display: block;
    border-radius: 0.6rem;
    max-height: ${(props) =>
      getSizeValue(props.size, {small: '300px', medium: '375px', large: '450px'})};
    background: #fff;
    overflow-y: scroll;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none;
    position: absolute;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    width: 100%;
    left: 0;
    top: 100%;
    z-index: 2;
  }
  .dropdown-menu .dropdown-menu__item {
    font-size: ${(props) =>
      getSizeValue(props.size, {small: '1.2rem', medium: '1.4rem', large: '1.6rem'})};
    color: #6c6c6c;
    text-align: center;
    border-radius: 0;
    padding: ${(props) =>
      getSizeValue(props.size, {small: '0', medium: '0.4rem 0', large: '0.6rem 0'})};
  }

  :hover {
    cursor: pointer;
    box-shadow: 4px 4px 20px rgb(0 0 0 / 25%);
  }

  @media (max-width: 768px) {
    width: 100%;
    height: ${(props) =>
      getSizeValue(props.size, {small: '2.8rem', medium: '3.6rem', large: '4.5rem'})};
    .dropdown-menu::after {
      display: none !important;
    }
  }

  @media (max-height: 660px) {
    height: ${(props) =>
      getSizeValue(props.size, {small: '2.8rem', medium: '3.6rem', large: '4.5rem'})};
  }

  @media (max-height: 600px) {
    height: ${(props) =>
      getSizeValue(props.size, {small: '2.8rem', medium: '3.6rem', large: '4.5rem'})};
  }
`;

Dropdown.propTypes = propTypes;

export default Dropdown;
